import React from 'react';
import './roundButtonsStyles.css';

/* 
isSelected : boolean
roundNumber : Number 
handleClick
*/
const RoundButton = (props) =>{
    const isSelected = props.isSelected ? "selected" : "";
    return (
        <button 
        className = {isSelected + " round-button"}
        value = {props.roundNumber}
        onClick = {props.handleClick}>
            Round {props.roundNumber+1}
        </button>
    )
}

/*
props : {
     length : Number
    round : Number 
}
*/
export const RoundButtons = (props) =>{
    const buttons = [...Array(props.length).keys()]
    
    return ( <div className = "round-buttons">
    { buttons.map((key) =>{
        return (<RoundButton
            isSelected = {props.round == key}
            roundNumber = {key}
            handleClick = {props.handleClick}
         />)
     })}
    </div>
    )
}